import { Box, Typography } from "@mui/material";

const BlockGame = () => {
  return (
    // Matches the v2 blocked chip: white pill, rounded, 1px red border, 30px
    // tall, red text, on a single line.
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: "30px",
        px: 1.5,
        bgcolor: "#fff",
        border: "1px solid #fca5a5",
        borderRadius: "8px",
        whiteSpace: "nowrap",
      }}
    >
      <Typography
        variant="body2"
        sx={{ color: "#dc2626", fontSize: 12, fontWeight: 600, lineHeight: 1 }}
      >
        Not Available in Your Region
      </Typography>
    </Box>
  );
};
export default BlockGame;
